const misc = {
  notFound: {
    title: "页面未找到",
    message: "您查找的页面不存在或已被移动。",
    backToHome: "返回首页",
    error404: "404",
  }
};

export default misc; 